import PropTypes from "prop-types";
import { useTheme } from "styled-components";
import classNames from "classnames";

import { getStatusColor } from "utils";
import { MobileStrategyControlCardContainer } from "./MobileStrategyControlCard.styles";
import { StrategyAction } from "features/Strategy/v2/List/Action";

const MobileStrategyControlCard = ({
  portfolio,
  handleStopStrategy,
  handleStartStrategy,
  handlePauseStrategy,
  handleChangeAllocationAmount,
  handleManageAllocation,
}) => {
  const theme = useTheme();
  const color = getStatusColor(portfolio.subscription_status, theme.mode);

  return (
    <MobileStrategyControlCardContainer
      className={classNames({
        "ineligible-row": !portfolio.eligible,
      })}
    >
      <div className="header">
        <img src={portfolio.brokerLogo} className="icon-broker" />
        <div className="name">{portfolio.broker_account_nickname}</div>
      </div>
      {portfolio.eligibility_message && (
        <div className="eligibility">{portfolio.eligibility_message}</div>
      )}
      {portfolio.eligible && (
        <>
          <div className="divider"></div>
          <div className="details-wrapper">
            <div className="status">
              <span style={{ color }}>{portfolio.subscription_status}</span>
            </div>

            <div className="btn-action">
              <StrategyAction
                rowData={portfolio}
                handleStopStrategy={handleStopStrategy}
                handleStartStrategy={handleStartStrategy}
                handlePauseStrategy={handlePauseStrategy}
                handleChangeAllocationAmount={handleChangeAllocationAmount}
                handleManageAllocation={handleManageAllocation}
              />
            </div>
          </div>
        </>
      )}
    </MobileStrategyControlCardContainer>
  );
};

MobileStrategyControlCard.propTypes = {
  portfolio: PropTypes.object,
  handleStopStrategy: PropTypes.func,
  handleStartStrategy: PropTypes.func,
  handlePauseStrategy: PropTypes.func,
  handleChangeAllocationAmount: PropTypes.func,
  handleManageAllocation: PropTypes.func,
};

export default MobileStrategyControlCard;
